import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-01/lesson-25/task-01";

const task: Slide = {
  titleHtml:
    "Consider a 20 mm-diameter cylindrical pipe at the entrance of which is placed a loudspeaker.<br>A burst (windowed sine) of central frequency 12 kHz and bandwidth 1 kHz is sent to the loudspeaker.<br>A microphone is placed at 1 m from the speaker. Calculate the cutoff frequency fc<sup>1</sup> of the first higher mode,<br>deduce its group velocity cg1 at the central frequency of the burst (without accounting for viscothermal losses),<br>and deduce the delay Δt between the arrival time at the microphone of this mode and that of the plane mode.<br>The celerity in air is 343 m/s.",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
